var buttonPillThemeNative = {
  borderRadius: {
    xs: 20,
    s: 24,
    m: 28,
    l: 32
  }
};
var buttonPillThemeWeb = {
  borderRadius: {
    xs: 20,
    s: 24,
    m: 28,
    l: 32
  }
};

export { buttonPillThemeNative, buttonPillThemeWeb };
